(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arinna-product-option2"] && !Shopify.designMode) return;
  try {
    
function a19GroupContent(root){
const source=root.querySelector('.a19p-description .a19p-rich');
if(!source)return;
const normalize=s=>s.toLowerCase().replace(/[’']/g,"'").replace(/\s+/g,' ').replace(/[:：]+$/,'').trim();
const included=new Set(['included','package includes','what is included','contents included','what you will receive','included in this sale','included in the sale','included in this set','included in this lot','included products','included components','items included','supplied with']);
const specs=new Set(['specifications','technical specifications','key specifications','technical details','manufacturer specifications','key manufacturer specifications','identification and specifications','specifications / details','manufacturer specifications / features']);
const classify=s=>included.has(normalize(s))?'included':specs.has(normalize(s))?'specs':null;
const isHeading=n=>n.nodeType===1&&(/^H[1-6]$/.test(n.tagName)||(n.tagName==='P'&&n.children.length===1&&/^(STRONG|B)$/.test(n.firstElementChild.tagName)&&normalize(n.textContent)===normalize(n.firstElementChild.textContent)));
const headings=Array.from(source.querySelectorAll('h1,h2,h3,h4,h5,h6,p')).filter(isHeading);
const seen=new Set();
for(const heading of headings){
const type=classify(heading.textContent);
if(!type)continue;
const target=root.querySelector('[data-auto-panel="'+type+'"]');
if(!target||target.dataset.manual==='true')continue;
const nodes=[];let node=heading.nextSibling;
while(node){
if(node.nodeType===1&&(isHeading(node)||node.querySelector('h1,h2,h3,h4,h5,h6')))break;
nodes.push(node);node=node.nextSibling;
}
if(!nodes.some(n=>n.textContent.trim()||(n.nodeType===1&&n.querySelector('img,video,table'))))continue;
const body=target.querySelector('.a19p-rich');
for(const n of nodes){if(!seen.has(n)){body.append(n.cloneNode(true));seen.add(n);}}
target.hidden=false;
}
for(const paragraph of source.querySelectorAll('p')){
const label=paragraph.firstElementChild;
if(!label||!/^(STRONG|B)$/.test(label.tagName)||normalize(paragraph.textContent)===normalize(label.textContent))continue;
if(paragraph.firstChild!==label&&paragraph.firstChild.textContent.trim())continue;
const type=classify(label.textContent);const target=type&&root.querySelector('[data-auto-panel="'+type+'"]');
if(!target||target.dataset.manual==='true'||seen.has(paragraph))continue;
const copy=paragraph.cloneNode(true);copy.firstElementChild.remove();
if(!copy.textContent.trim())continue;
target.querySelector('.a19p-rich').append(copy);target.hidden=false;seen.add(paragraph);
}
}
function a19Init(){
document.querySelectorAll('.a19p').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
a19GroupContent(root);
root.querySelectorAll('[data-image]').forEach(button=>button.addEventListener('click',()=>{
const img=root.querySelector('.a19p-main');img.removeAttribute('srcset');img.src=button.dataset.image;root.querySelector('.a19p-photo').href=button.dataset.full;
}));
const select=root.querySelector('select[name=id]');if(select)select.addEventListener('change',()=>{const url=new URL(location.href);url.searchParams.set('variant',select.value);location.href=url.href;});
});}
a19Init();document.addEventListener('shopify:section:load',a19Init);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
